import { Box, Typography } from "@mui/material";
import CreateRobotScreen from "../create";
import { COLOR } from "../../../../utils/colors";
import { useNavigate } from "react-router-dom";
import { showSuccessToast } from "../../../../utils/utils";

export default function CreateRobotPage() {
  const navigate = useNavigate()
  const onCancel = () => {
    navigate('/config/robots', {
      replace: true
    })
  }

  const onSubmit = () => {
    showSuccessToast('Robot created successfully')
    navigate('/config/robots', {
      replace: true
    })
  }
  return (
    <Box sx={{ padding: '36px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', mb: '24px' }}>
        <Typography
          sx={{
            fontSize: '24px',
            fontWeight: 600,
            color: COLOR.neutral[900]
          }}
        >
          Create Robot
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: COLOR.neutral[900],
            opacity: 0.6,
          }}
        >
          Fill in the details below to create a new robot.
        </Typography>
      </Box>
      <CreateRobotScreen onCancel={onCancel} hideTitle onSubmit={onSubmit} />
    </Box>
  )
}